import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandJobEngineInstanceStopPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandJobEngineInstanceStopProperties = {
    [name in keyof EntityCommandJobEngineInstanceStopPropertyValues]: Property<EntityCommandJobEngineInstanceStopPropertyValues[name]>
};

export interface IEntityCommandJobEngineInstanceStop extends IEntityCommand, EntityCommandJobEngineInstanceStopProperties
{
}

export class EntityCommandJobEngineInstanceStop extends EntityCommand implements IEntityCommandJobEngineInstanceStop
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandJobEngineInstanceStop";
    public static override className = "EntityCommandJobEngineInstanceStop";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandJobEngineInstanceStopPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Stop",
                entityName: "JobEngineInstance",
                key: "STOP",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandJobEngineInstanceStopPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            recordId = entityCommandInformation.getRecordId();

        if (!recordId)
            return;

        await (
            ServiceManager.getRequired(WebApiClientService)
                .createApiMethodRequest("DataService", "CallDataService", { id: "202c4702-7f0f-4b6a-aea9-1f2e959854e2", operation: "StopJobEngineInstance", data: ObjectHelper.toJson({ jobEngineInstanceId: recordId }) })
                .executeAsync()
        );
    }

    // #endregion

    // #endregion
}

